import {React, useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateTableActions } from '../../store/update-table-slice';
import {useNavigate} from 'react-router-dom';
import axios from 'axios';
import { Delete} from '@mui/icons-material';
import Notification from '../Notification';
import ConfirmDialog from '../ConfirmDialog';

let fetch_id = 0;
let delete_id = 0;
export default function HolidayMasterTable(props) {



  const [openPopup, setOpenPopup] = useState(false);
  const [holidays, setHolidays] = useState([]);
  const [notify, setNotify] = useState({isOpen: false, message: '', type: ''});
  const [confirmDialog, setConfirmDialog] = useState({isOpen: false, title: '', subTitle: ''});
  const dispatch = useDispatch();
  const updateCompanyHolidays = useSelector(state => state.updateTable.updateCompanyHolidays);
  const navigate = useNavigate();

  async function getAllLeaveTypes(){
    try {
      const holidays = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/company-master/holiday-master/view-all`);
      // console.log(holidays.data);       
      if(props.yearSelected !== "true"){
          setHolidays(holidays.data);
      } else {
          setHolidays(props.filteredHolidays);
      }            
    } catch (e) {
      if(e.response.status === 401) {
        setNotify({
          isOpen: true,
          message: 'Session Expired!',
          type: 'error'
        });
        setTimeout(() => {
          navigate('/');
        },1000);
      }
    }
  }

  useEffect(()=>{
    getAllLeaveTypes();
  }, []);

  useEffect(()=>{
    if(updateCompanyHolidays){
      getAllLeaveTypes();
      dispatch(updateTableActions.stopUpdateCompanyHolidays());
    }
  }, [updateCompanyHolidays]);

  const handleDelete = async (delete_id) => {
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    try {
      const res = await axios.delete(`${process.env.REACT_APP_API_BASE_URL}/company-master/holiday-master/delete/` + delete_id);

      if(res.status === 200) {
        getAllLeaveTypes();
        setNotify({
          isOpen: true,
          message: 'Successfully Deleted!',
          type: 'error'
        });
      }
      dispatch(updateTableActions.startUpdateCompanyHolidays());
    } catch (e) {
      if(e.response.status === 401) {
        setNotify({
          isOpen: true,
          message: 'Session Expired!',
          type: 'error'
        });
        setTimeout(() => {
          navigate('/');
        },1000);
      }
    }
  }

  return (
    <div>

    <table class="table">
        <thead class="table-dark">
          <tr>       
            <th scope="col">Holiday Date</th>
            <th scope="col">Reason for Holiday</th>
            <th class="table-dark"></th>
          </tr>
        </thead>
        <tbody>
          {holidays.map((holiday , i) => {
            return (
              <>
                <tr>   
                  <td>{holiday.holiday_date}</td>
                  <td>{holiday.holiday_reason}</td>
                  <td><button type="button" class="btn btn-outline-danger btn-sm" onClick={() => setConfirmDialog({
                      isOpen: true,
                      title: 'Are you sure to delete this record?',
                      subTitle: "You can't undo this operation",
                      onConfirm: () => {handleDelete(delete_id=holiday.holiday_id)}
                    })}
                  > <Delete/> Delete </button></td>
                </tr>
            </>
          )
        })}

        </tbody>
      </table>
      <Notification
            notify={notify}
            setNotify={setNotify} />
        <ConfirmDialog
          confirmDialog={confirmDialog}
          setConfirmDialog={setConfirmDialog} />
    </div>

  );
}
